var patt = /(\s*([^>\s/]*))/g
export default function (str, pos) {
  var quote = str.charAt(pos)
  if (quote === '"' || quote === "'") {
    var nextQuote = str.indexOf(quote, pos + 1)
    if (nextQuote === -1) {
      return { length: str.length - pos, value: str.substring(pos + 1) }
    } else {
      return { length: (nextQuote - pos) + 1, value: str.substring(pos + 1, nextQuote) }
    }
  } else {
    patt.lastIndex = pos
    var match = patt.exec(str)
    return { length: match[1].length, value: match[2] }
  }
}


// WEBPACK FOOTER //
// ./src/common/components/process-editor/modules/dinnerSvg/tokenizer/readAttribute.js